import { getSystemParam } from '../platform';

export async function getClientLanguage() {
  try {
    const param = await getSystemParam();
    return param.globalLang;
  } catch (e) {
    console.warn('getSystemParam failed, fallback to navigator', navigator, e);
    return (window as any)._zm_lang || navigator.language;
  }
}
export default {
  getClientLanguage,
};
